import { render, staticRenderFns } from "./ExpandableView.vue?vue&type=template&id=2d2559d2&scoped=true&"
import script from "./ExpandableView.vue?vue&type=script&lang=ts&"
export * from "./ExpandableView.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandableView.vue?vue&type=style&index=0&id=2d2559d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2559d2",
  null
  
)

export default component.exports